// extracted by mini-css-extract-plugin
export default {"hideTooltip":"G_-z","fadeIn":"H_-z","delay":"I_-z","recommendedSizeTooltip":"J_-z"};